<p role="status" class="sr-only">{{landingAnnouncementString}}</p>
<h1>CPD Self-Assessment</h1>
<div *ngIf="stepStatus && (plan && plan.Status !== 'Complete' || isEditing)">
  <mat-stepper [animationDuration]="'500'" [orientation]="(stepperOrientation | async)!" #stepper
    (selectionChange)="stepChanged($event);" [selectedIndex]="stepStatus.Step - 1" linear>
    <ng-template matStepperIcon="edit" let-index="index">
      <mat-icon (mouseover)="getTooltip(index)" [matTooltip]="mouseOverTooltip">create</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="done" let-index="index">
      <mat-icon (mouseover)="getTooltip(index)" [matTooltip]="mouseOverTooltip">done</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="number" let-index="index">
      <span (mouseover)="getTooltip(index)" [matTooltip]="mouseOverTooltip">{{index + 1}}</span>
    </ng-template>
    <mat-step label="Introduction" #step_1 [completed]="stepStatus.Step > 1">
      <ng-template matStepContent>
        <app-introduction></app-introduction>
        <div class="button-wrapper">
          <button appNoDblClick type="button" mat-raised-button class="buttonClass" color="primary" (click)="savePage(2)">Step 2<i
              data-feather="chevron-right"></i></button>
        </div>
      </ng-template>
    </mat-step>
    <mat-step label="PD Goals" #step_2 [completed]="stepStatus.Step > 2">
      <ng-template matStepContent>
        <app-pdgoals></app-pdgoals>
        <div class="button-wrapper">
          <button type="button" mat-raised-button color="white" matStepperPrevious><i
              data-feather="chevron-left"></i>Step
            1</button>
          <button appNoDblClick type="button" mat-raised-button class="buttonClass" color="primary" (click)="savePage(3)">Step 3<i
              data-feather="chevron-right"></i></button>
        </div>
      </ng-template>
    </mat-step>
    <mat-step label="Select Competencies" #step_3 [completed]="stepStatus.Step > 3">
      <ng-template matStepContent>
        <app-select-competencies
          [competencies]="plan?.Competencies" [savedCompetencies]="savedCompetencies" [planId]="plan.Id" [nextButton]="nextButton"></app-select-competencies>
        <div class="button-wrapper">
          <button type="button" mat-raised-button color="white" matStepperPrevious><i
              data-feather="chevron-left"></i>Step 2</button>
          <button [disabled]="isButtonLoading || (plan?.Competencies?.length ?? 0) < 2" #nextButton appNoDblClick type="button" mat-raised-button class="buttonClass" color="primary" (click)="saveCompetenciesPage()"><mat-icon *ngIf="isButtonLoading"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>Step 4<i
              data-feather="chevron-right"></i></button>
        </div>
      </ng-template>
    </mat-step>
    <mat-step label="Self-Assessment" #step_4 [completed]="stepStatus.Step > 4">
      <ng-template matStepContent>
        <app-self-assessment [competencies]="plan?.Competencies" (toggleButton)="disableButtons($event)"></app-self-assessment>
        <div class="button-wrapper">
          <button [disabled]="disableSetLearningButtons||isButtonLoading" type="button" mat-raised-button color="white" matStepperPrevious><i
              data-feather="chevron-left"></i>Step 3</button>
          <button [disabled]="disableSetLearningButtons||isButtonLoading" appNoDblClick type="button" class="buttonClass" mat-raised-button color="primary" (click)="saveSelfAssessmentPage()"><mat-icon *ngIf="isButtonLoading"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>Step 5<i
              data-feather="chevron-right"></i></button>
        </div>
        <div class="principa-footer">Professional Foundations Proficiency Scale by Principia Assessments Ltd. is
          licensed
          under CC BY-NC-ND 4.0</div>
      </ng-template>
    </mat-step>
    <mat-step label="Set Priorities" #step_5 [completed]="stepStatus.Step > 5">
      <ng-template matStepContent>
        <app-set-priorities [competencies]="plan?.Competencies" [savedCompetencies]="savedCompetencies" (toggleButton)="disableButtons($event)"></app-set-priorities>
        <div class="button-wrapper priority">
          <button [disabled]="disableSetLearningButtons||isButtonLoading" type="button" mat-raised-button color="white" matStepperPrevious><i data-feather="chevron-left"></i>
            Step 4</button>
          <button [disabled]="disableSetLearningButtons||isButtonLoading" appNoDblClick type="button" mat-raised-button class="buttonClass" color="primary" matStepperNext (click)="saveSetPrioritiesPage()"><mat-icon *ngIf="isButtonLoading"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>Step
            6<i data-feather="chevron-right"></i></button>
        </div>
      </ng-template>
    </mat-step>
    <mat-step label="Set Learning Activities" #step_6 [completed]="stepStatus.Step > 6">
      <ng-template matStepContent>
        <app-set-learning [competencies]="plan?.Competencies"
          [year]="plan?.PlanYear" [savedCompetencies]="savedCompetencies" (toggleButton)="disableButtons($event)"></app-set-learning>
        <div class="button-wrapper">
          <button [disabled]="disableSetLearningButtons||isButtonLoading" type="button" mat-raised-button color="white" matStepperPrevious><i
              data-feather="chevron-left"></i>Step
            5</button>
          <button [disabled]="disableSetLearningButtons||isButtonLoading" appNoDblClick type="button" class="buttonClass" mat-raised-button color="primary"
            (click)="saveSetLearning()"><mat-icon *ngIf="isButtonLoading"><mat-spinner diameter="20">
            </mat-spinner></mat-icon>Review<i data-feather="chevron-right"></i></button>
        </div>
      </ng-template>
    </mat-step>
    <mat-step label="Review and Submit" #step_7 [completed]="stepStatus.Step > 7">
      <ng-template matStepContent>
        <app-review [competencies]="plan?.Competencies" [stepper]="stepper"></app-review>
        <div class="button-wrapper">
          <button type="button" mat-raised-button color="white" matStepperPrevious><i
              data-feather="chevron-left"></i>Step 6</button>
          <button [disabled]="isButtonLoading" appNoDblClick type="button" mat-raised-button color="primary" matStepperNext class="acknowledge buttonClass" (click)="submitPlan()">Acknowledge and
            submit my CPD Plan<i data-feather="chevron-right"></i></button>
        </div>
      </ng-template>
    </mat-step>
  </mat-stepper>
</div>
<div *ngIf="stepStatus && plan && plan.Status === 'Complete' && !isEditing" class="info-complete">
  <mat-card appearance="outlined" class="complete">
    <p>Your CPD Self-Assessment is complete and has been submitted to the Law Society. To review and/or edit your plan, go to the <a [routerLink]="['/app/view-plan', plan.Id]">View/Edit Plan</a> tab.</p>
  </mat-card>
</div>
